import React, { ReactElement } from "react";
import styled from "styled-components";
import { ValidationResponse, ValidationTypes } from "types/validation";
import DangerousOutlinedIcon from "@mui/icons-material/DangerousOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const validationTypeToIcon = (type: ValidationTypes): ReactElement => {
  switch (type) {
    case ValidationTypes.ERROR:
      return (
        <DangerousOutlinedIcon
          color="error"
          fontSize="large"
          aria-label="Error"
        />
      );
    case ValidationTypes.WARNING:
      return (
        <WarningAmberOutlinedIcon
          color="warning"
          fontSize="large"
          aria-label="Warning"
        />
      );
    case ValidationTypes.INFO:
      return (
        <InfoOutlinedIcon color="info" fontSize="large" aria-label="Info" />
      );
    default: {
      return (
        <DangerousOutlinedIcon
          color="error"
          fontSize="medium"
          aria-label="Error"
        />
      );
    }
  }
};

export default function ValidationMessages({
  validations,
}: {
  validations: ValidationResponse[];
}) {
  return (
    <MessageWrapper>
      {validations.map(({ id, message, type }) => (
        <MessageRow key={id}>
          {validationTypeToIcon(type)}
          <Message>{message ?? ""}</Message>
        </MessageRow>
      ))}
    </MessageWrapper>
  );
}

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MessageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`;

const Message = styled.div`
  font-size: 14px;
`;
